import EmailConfigurations from 'components/EmailConfigurations';
import { EmailConfigContainer } from './style';

const EmailConfig = (props) => {
  const { data, setData } = props;
  const updateEmailConfig = (selected) => {
    setData({
      ...data,
      notification: { ...data?.notification, isSingleEmailThread: selected },
    });
  };
  return (
    <EmailConfigContainer>
      <EmailConfigurations
        selected={data?.notification?.isSingleEmailThread}
        onChangeCB={updateEmailConfig}
        isWorkflow={true}
      />
    </EmailConfigContainer>
  );
};

export default EmailConfig;
